/** 정기결제 주문서 스토리지 복원 타입 */
export const STORAGE_RECOVERY_TYPE = {
    // 페이포인트, 선택한 결제수단(acctKey, cid 포함), 현금영수증 선택 state 복원
    ALL: 'ALL',
    // 페이포인트, 선택한 결제수단(acctKey, cid 비포함), 현금영수증 선택 state 복원
    EXCLUDE_PAYMENTS_ID: 'EXCLUDE_PAYMENTS_ID',
    // ARS -> 휴대폰 결제 모듈 노출을 위해 state 값 복원에 사용하는 타입
    // ALL 타입에서 payments, product, common을 추가적으로 포함
    ARS: 'ARS',
} as const

export type StorageRecoveryType = Constant<typeof STORAGE_RECOVERY_TYPE>
